import React, { memo, useCallback, useMemo } from "react";

// core-ui components
import { LottieAnimation } from "@swiggy-private/core-ui";

// utils
import { getCloudinaryRawUrl, TEAM_LINE } from "@swiggy-private/js-utils";

// constants
import { LOTTIE_ASSETS } from "@swiggy-private/core-ui";

// styled component
import { LottieContainer } from "./FreebieWidgetLottie.styles";

interface FreebieWidgetLottieProps {
    isVisible: boolean;
    onLottieComplete?: () => void;
    onLottieError?: () => void;
}

const FreebieWidgetLottie: React.FC<FreebieWidgetLottieProps> = ({
    isVisible,
    onLottieComplete,
    onLottieError,
}) => {
    const handleLottieComplete = useCallback(() => {
        onLottieComplete?.();
    }, [onLottieComplete]);

    const handleLottieError = useCallback(() => {
        onLottieError?.();
    }, [onLottieError]);

    const lottiePath = useMemo(() => {
        return getCloudinaryRawUrl(
            LOTTIE_ASSETS.FREEBIE_WIDGET_LOTTIE_FILE_ID,
            {},
            { teamLine: TEAM_LINE.PORTAL },
        );
    }, []);

    if (!isVisible) return null;

    return (
        <LottieContainer>
            <LottieAnimation
                fileName={lottiePath}
                visible={isVisible}
                playLottie={isVisible}
                autoplay={isVisible}
                loop={false}
                backwardSpeed={1}
                forwardSpeed={1}
                playIfVisible={false}
                onPlayComplete={handleLottieComplete}
                onError={handleLottieError}
                preserveAspect="xMidYMid meet"
                enableFrameEvent
            />
        </LottieContainer>
    );
};

export default memo(FreebieWidgetLottie);
